import { render } from "./informeMensualGestion.vue?vue&type=template&id=b117df34&scoped=true"
import script from "./informeMensualGestion.vue?vue&type=script&lang=js"
export * from "./informeMensualGestion.vue?vue&type=script&lang=js"

import "./informeMensualGestion.vue?vue&type=style&index=0&id=b117df34&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b117df34"]])

export default __exports__